import React, {useRef, useState} from 'react';
import Questions from '../../SurveyQuestions';
import styles from './styles';
import config from '../../../config/axios.config';
import axios from 'axios';
import { trackError } from '../../../utils/activityTracker'
import { UserContext } from '../../../Context/UserContext'

export const SurveyQuestions = props => {
  const overviewForm = useRef({surveyQuestions: null});
  const [questionData, setQuestionData] = useState(false);
  const [edit, setEdit] = useState(false)
  const { userAction } = React.useContext(UserContext)
  const mounted = React.useRef(true);
  React.useEffect(() => () => mounted.current = false, []);

  const refresh = () => {
    axios.get(`${config.apiUrl}/rt/console/survey-questions/${props.instance}`).then(response => {
      console.log(response, "RESPONSE")
      let newQuestionData = {}
      if(response.data.questions) overviewForm.current.surveyQuestions = response.data.questions;
      if(response.data.instanceData) newQuestionData.instanceData = response.data.instanceData;
      if (mounted.current) {
        setQuestionData(newQuestionData)
        setEdit(false)
      }
    }).catch(err => {
      console.log(err)
      trackError({ error: err, history: props.history })
      if (err.response && err.response.status === 403) {
        userAction({type: 'logout'})
      }
    })
  }

  if(!questionData) refresh()

  const toggleEdit = e => setEdit(!edit)

  const saveSurvey = e => axios.post(
    `${config.apiUrl}/rt/console/save-survey-questions/${props.instance}`,
    {questions: overviewForm.current.surveyQuestions, email: props.auth.email}
  ).then(response => {
    refresh()
  }).catch(err => {
    console.log(err)
    trackError({ error: err, history: props.history })
    if (err.response && err.response.status === 403) {
      userAction({type: 'logout'})
    }
  })

  return (
    <div style={styles.container}>
      {
        questionData.instanceData && <Questions
          {...props}
          overviewForm={overviewForm}
          type='surveyQuestions'
          instance={props.instance}
          saveSurvey={saveSurvey}
          instanceSettings={questionData.instanceData}
          edit={edit}
          toggleEdit={toggleEdit}
        />
      }
    </div>
  )
}
